import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Calendar, Play } from "lucide-react";

interface Practice {
  name: string;
  description?: string;
  yardage?: number;
  practice_time?: string;
}

interface TodaysPracticeCardProps {
  practice: Practice | null;
  onStartPractice?: () => void;
  formatNumber?: (n: number | string) => string;
}

/**
 * Card component displaying today's practice information
 */
export function TodaysPracticeCard({ 
  practice, 
  onStartPractice,
  formatNumber = (n) => typeof n === "number" ? n.toLocaleString() : n
}: TodaysPracticeCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Calendar className="mr-2 h-5 w-5" />
          Today's Practice
        </CardTitle>
        <CardDescription className="break-words [overflow-wrap:anywhere]">
          {practice ? practice.description || "No description available" : "Endurance Focus - Week 3"}
        </CardDescription>
      </CardHeader>

      <CardContent className="space-y-4">
        {practice ? (
          <>
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-medium break-words [overflow-wrap:anywhere]">{practice.name}</p>
                  <p className="text-sm text-muted-foreground">
                    Total Yardage: {formatNumber(practice.yardage || 0)} m
                  </p>
                </div>
                <Badge variant="outline">{practice.practice_time || "—"}</Badge>
              </div>
            </div>

            <div className="pt-4">
              <Button className="w-full" onClick={onStartPractice}>
                <Play className="mr-2 h-4 w-4" />
                Begin Workout
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-medium">Warm-up</p>
                  <p className="text-sm text-muted-foreground">400m easy freestyle</p>
                </div>
                <Badge variant="outline">10 min</Badge>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-medium">Main Set</p>
                  <p className="text-sm text-muted-foreground">8 x 100m @ 1:30</p>
                </div>
                <Badge variant="outline">25 min</Badge>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="font-medium">Cool Down</p>
                  <p className="text-sm text-muted-foreground">200m backstroke easy</p>
                </div>
                <Badge variant="outline">8 min</Badge>
              </div>
            </div>

            <div className="pt-4">
              <Button className="w-full" onClick={onStartPractice}>
                <Play className="mr-2 h-4 w-4" />
                Begin Workout
              </Button>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}

